import { PlayCircle } from "lucide-react";
import Reveal from "@/components/Reveal";
import { VIDEOS } from "@/data/site";

export default function Videos() {
  return (
    <div data-testid="videos-page">
      <section className="parchment border-b border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <div className="eyebrow mb-6">Films & Interviews</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.95] max-w-4xl">
              Engines, voices, and the <span className="italic text-[color:var(--brg)]">long way round.</span>
            </h1>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-10 text-lg md:text-xl text-[color:var(--ink-secondary)] max-w-3xl">
              Walk‑arounds, owner interviews, Geneva Concours wins, donut drives, and the occasional Wolseley wedding.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[color:var(--surface)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {VIDEOS.map((v, idx) => (
              <Reveal key={v.url + idx} delay={(idx % 3) * 80}>
                <a
                  href={v.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`video-${idx}`}
                  className="block group"
                >
                  <div className="tile aspect-video relative">
                    <img src={v.thumb} alt={v.title} className="w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 flex items-center justify-center bg-[color:var(--ink)]/30 opacity-0 group-hover:opacity-100 transition">
                      <PlayCircle size={64} className="text-[color:var(--bg)]" strokeWidth={1.2} />
                    </div>
                  </div>
                  <div className="mt-4 flex items-baseline justify-between">
                    <div className="font-display text-2xl tracking-tight group-hover:text-[color:var(--brg)] transition">
                      {v.title}
                    </div>
                    <span className="text-xs uppercase tracking-[0.22em] text-[color:var(--ink-muted)]">Watch</span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-20 border-t border-[color:var(--accent)] pt-10 text-center">
              <p className="font-display italic text-2xl text-[color:var(--ink-secondary)]">
                Thanks to Steve Rosenblum & Phil Gullet for some of the videos
                <span className="block text-base mt-2">— and Richard Smyth for the artwork.</span>
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
